import { Badge } from '@radix-ui/themes';
import { CommonConfirmationDialog } from 'components/common/dialogs/confirmation';
import { MachineContext } from 'contexts/machine.context';
import { BallType } from 'lib_ts/enums/machine.enums';
import { RADIX } from 'lib_ts/enums/radix-ui';
import { useContext } from 'react';

interface IProps {
  nextBallType: BallType;
  onContinue: () => void;
}

export const CommonConfirmBallType = (props: IProps) => {
  const { machine } = useContext(MachineContext);

  return (
    <CommonConfirmationDialog
      identifier="CommonConfirmBallType"
      title="common.warning"
      content={
        <p>
          Please ensure you have switched all balls in the machine from{' '}
          <Badge color={RADIX.COLOR.NEUTRAL}>{machine.ball_type}</Badge> to{' '}
          <Badge color={RADIX.COLOR.ACCENT}>{props.nextBallType}</Badge> before
          continuing.
        </p>
      }
      action={{
        label: 'common.continue',
        color: RADIX.COLOR.ACCENT,
        onClick: () => props.onContinue(),
      }}
    />
  );
};
